/**
Author - Nandan Bilagi
Github - https://www.github.com/nandanwealthy/
**/

import ClientInsuranceSolution from "./client-insurance-solution"

export default ClientInsuranceSolution

export { getStaticProps } from "./client-insurance-solution"
